// extracted by mini-css-extract-plugin
export default {"Overlay":"Episodes_Overlay__Fn-Vc","Modal":"Episodes_Modal__2mBQ-","VideoCanvas":"Episodes_VideoCanvas__8FHx8"};